import React, { Component } from "react";
import { observer } from "mobx-react";

import OrderListTypeItemView from "./OrderListTypeItemView";

@observer
class OrderListTypeView extends Component {
  render() {
    const { rootStore } = this.props;
    const orderList = rootStore.orderStore.getOrderList;

    return (
      <div className="list_type_content">
        <ul className="list">
          {Array.isArray(orderList) && orderList.length > 0
            ? orderList.map((order, index) => (
                <OrderListTypeItemView
                  key={index}
                  index={index}
                  rootStore={rootStore}
                  order={order}
                ></OrderListTypeItemView>
              ))
            : null}
        </ul>
      </div>
    );
  }
}

export default OrderListTypeView;
